import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const buttonTypeClassNameStrategy = {
  primary: 'primary'
};

const Button = ({ onClick, children, type, className, disabled }) => (
  <button onClick={onClick} disabled={disabled} className={`Button ${buttonTypeClassNameStrategy[type]} ${className}`}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['primary']),
  disabled: PropTypes.bool
};

Button.defaultProps = {
  type: 'primary',
  onClick: null,
  className: '',
  children: null,
  disabled: false
};

export default Button;
